import { useMemo } from "react";
import { imageLoader } from "../../../../../utils/imageLoader";

const ResponsableProgramme = ({ program }) => {
  const uniqueUsers = useMemo(() => {
    const userMap = new Map();

    program?.forEach((access) => {
      access.secteur.users.forEach((user) => {
        if (!userMap.has(user.id)) {
          userMap.set(user.id, user);
        }
      });
    });

    return Array.from(userMap.values());
  }, [program]);

  return (
    <section id="responsableProgramme" className="mt-70">
      <p className="semibold fs16 pink mb-10">Responsable Programme</p>
      <div className="bg-white radius5 position-relative pink responsable-grid-container py-10 text-center mb-10 pink semibold ">
        <div>Nom</div>
        <div>Rôle</div>
        <div>Email</div>
        <div>Téléphone</div>
        <div></div>
      </div>
      {uniqueUsers?.length ? (
        uniqueUsers.map((user) => (
          <div
            key={user.id}
            className="bg-white radius5 position-relative responsable-grid-container text-center align-items-center fs14 darkGrey semibold mb-10"
          >
            <div className="d-flex gap10 align-items-center px-2 py-2 justify-content-start ms-4">
              <img
                src={imageLoader(user.profile_image)}
                alt=""
                height={80}
                width={80}
                className="rounded-circle object-fit-cover"
                style={{ objectFit: "contain" }}
              />
              <p>{user.name}</p>
            </div>
            <div>{user.profile}</div>
            <div className="d-flex flex-column gap10">
              <a href={`mailto:${user.email}`}>{user.email}</a>
            </div>
            <div>
              {user.phone_number ? (
                <a href={`tel:${user.phone_number}`}>{user.phone_number}</a>
              ) : (
                "Pas de numéro de téléphone"
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="fs14 darkGrey text-center">Aucun responsable trouvé</p>
      )}
    </section>
  );
};

export default ResponsableProgramme;
